
export const errorCodes: { [key: string]: string } = {
  400: 'Bad Request – The server could not understand the request due to invalid syntax.',
  401: 'Unauthorized – Authentication is required and has failed or has not yet been provided.',
  402: 'Payment Required – Reserved for future use (sometimes used for payment APIs).',
  403: 'Forbidden – You do not have permission to access the requested resource.',
  404: 'Not Found – The requested resource could not be found on the server.',
  405: 'Method Not Allowed – The request method is known by the server but has been disabled.',
  408: 'Request Timeout – The server timed out waiting for the request.',
  409: 'Conflict – The request could not be completed due to a conflict with the current state.',
  422: 'Unprocessable Entity – The request was well-formed but could not be followed due to semantic errors.',
  429: 'Too Many Requests – You have sent too many requests in a given amount of time (rate limiting).',

  // Server errors
  500: 'Internal Server Error – The server has encountered a situation it doesn’t know how to handle.',
  501: 'Not Implemented – The server does not support the functionality required to fulfill the request.',
  502: 'Bad Gateway – The server received an invalid response from the upstream server.',
  503: 'Service Unavailable – The server is not ready to handle the request.',
  504: 'Gateway Timeout – The server is acting as a gateway and cannot get a response in time.',

  //checkout

  2001: 'CHECKOUT_SESSION_EXPIRED',
  2002: 'CART_IS_EMPTY_WITH_PRODUCTS',
  2003: 'PAYMENT_METHOD_MISSING',
  2004: 'SHIPPING_ADDRESS_MISSING',
  2005: 'SHIPPING_ADDRESS_MOBILE_NOT_VERIFIED',
  2006: 'COUPON_INVALID',
  2007: 'INSUFFICIENT_STOCK',
  2008: 'PRODUCT_VARIANT_EXPIRED',
  2009: 'PRODUCT_VARIANT_NOT_LIVE',

  // address
  7400:"Shipping Address is not set",

  // order
  3001:"Order Not Found for this user"
  
};